import { useEffect, useState } from 'react';

const OBSCURED_BELOW = 0.85;

/** True while the top-level viewport clips most of this frame away — the host
 *  pushing its content aside for the mobile menu drawer. Keys off that push:
 *  if the host menu ever becomes a pure overlay (no push), the ratio stops
 *  moving and this must become a host-emitted bridge event instead. */
export function useObscured(): boolean {
  const [obscured, setObscured] = useState(false);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(
      (entries) => {
        const last = entries[entries.length - 1];
        if (last) setObscured(last.intersectionRatio < OBSCURED_BELOW);
      },
      { threshold: [OBSCURED_BELOW] },
    );
    observer.observe(document.documentElement);
    return () => observer.disconnect();
  }, []);

  return obscured;
}
